// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { baseUrl } from './../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getAllMentorList = createAsyncThunk(
  'mentorMaster/getAllMentorList',
  async (params) => {
    const response = await axios.get(baseUrl() + '/user-mentor/mentors', {
      params
    })
    return {
      totalPages: response?.data?.count?.total,
      params: response.data.count,
      mentorsList: response.data.data
    }
  }
)
export const getAllMentorsDropdown = createAsyncThunk(
  'mentorMaster/getAllMentorsDropdown',
  async (params) => {
    const response = await axios.get(baseUrl() + '/user-mentor/mentors', {
      params
    })
    return {
      mentorsListDropdown: response.data.data
    }
  }
)

export const getAllMentor = createAsyncThunk(
  'mentorMaster/getAllMentor',
  async (params) => {
    const response = await axios.get(
      baseUrl() + '/user-mentor/mentorsList/all',
      {
        params
      }
    )
    return {
      params: response.data.params,
      mentorsListData: response.data.data
    }
  }
)

export const getMentorsByUserId = createAsyncThunk(
  'mentorMaster/getMentorsByUserId',
  async ({ id }) => {
    const response = await axios.get(baseUrl() + '/user-mentor/' + id)
    return {
      mentorsListByUserId: response.data.data
    }
  }
)

export const getAllUserMentorList = createAsyncThunk(
  'mentorMaster/getAllUserMentorList',
  async (params) => {
    const response = await axios.get(baseUrl() + '/user-mentor', { params })
    return {
      totalPages: response?.data?.count?.total,
      params: response.data.count,
      userMentorList: response.data.data
    }
  }
)

export const addMentorToUser = createAsyncThunk(
  'mentorMaster/addMentorToUser',
  async ({ mentorId, userId, pageNo, pageSize }, { dispatch }) => {
    try {
      const res = await axios.post(baseUrl() + '/user-mentor', { mentorId, userId })
      toast.success(res?.data?.message)
      await dispatch(
        getAllUserMentorList({
          pageNo,
          pageSize,
          name: 'MENTOR'
        })
      )
      //return assignTopic
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const updateMentorForUser = createAsyncThunk(
  'mentorMaster/updateMentorForUser',
  async (
    { mentorId, userId, pageNo, pageSize, search },
    { dispatch, getState }
  ) => {
    try {
      const res = await axios.put(baseUrl() + '/user-mentor', { mentorId, userId })
      toast.success(res?.data?.message)
      await dispatch(
        getAllUserMentorList({
          pageNo,
          pageSize,
          search
        })
      )
      return true
    } catch (error) {
      return false
      toast.error(error?.response?.data?.message)
    }
  }
)

export const deleteUserMentor = createAsyncThunk(
  'mentorMaster/deleteUserMentor',
  async ({ id, pageNo, pageSize }, { dispatch }) => {
    try {
      const res = await axios.delete(baseUrl() + '/user-mentor/' + id)
      toast.success(res?.data?.message)
      await dispatch(
        getAllUserMentorList({
          pageNo,
          pageSize
        })
      )
      return id
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const MentorMasterSlice = createSlice({
  name: 'mentorMaster',
  initialState: {
    mentorsList: [],
    userMentorList: [],
    mentorsListByUserId: [],
    mentorsListData: [],
    mentorsListDropdown: [],
    loader: true,
    totalPages: 0,
    selected: null,
    params: {}
  },
  reducers: {
    selectMentorMaster: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUserMentorList.fulfilled, (state, action) => {
        state.userMentorList = action.payload.userMentorList
        state.totalPages = action.payload.totalPages
        state.params = action.payload.params
        state.loader = false
      })
      .addCase(getAllMentorList.fulfilled, (state, action) => {
        state.mentorsList = action.payload.mentorsList
        state.totalPages = action.payload.totalPages
        state.params = action.payload.params
        state.loader = false
      })
      .addCase(getAllMentorsDropdown.fulfilled, (state, action) => {
        state.mentorsListDropdown = action.payload.mentorsListDropdown
      })
      .addCase(getMentorsByUserId.fulfilled, (state, action) => {
        state.mentorsListByUserId = action.payload.mentorsListByUserId
      })
      .addCase(getAllMentor.fulfilled, (state, action) => {
        state.mentorsListData = action.payload.mentorsListData
      })
  }
})

export const { selectMentorMaster, setLoader } = MentorMasterSlice.actions

export default MentorMasterSlice.reducer
